<template>
<div class="chapter">
<div class="inner_page">
<h1 id="heading_id_2">Contents<br/></h1>
<p class="first"><a href="#/Text/Introduction">Introduction: <em>Resurrection of Another Kind</em></a></p>
<p class="first"><a href="#/Text/03CHAP01">1 Character: <em>Sailing with the Wind’s Full Force</em></a></p>
<p class="first"><a href="#/Text/04CHAP02">2 Courage: <em>Overcoming Crippling Fears</em></a></p>
<p class="first"><span href="#/Text/05CHAP03" title="Link target outside of Sample">3 Discipline: <em>Achieving Success by Delaying Gratification</em></span></p>
<p class="first"><span href="#/Text/06CHAP04" title="Link target outside of Sample">4 Vision: <em>Looking Beyond the Obvious</em></span></p>
<p class="first"><span href="#/Text/07CHAP05" title="Link target outside of Sample">5 Endurance: <em>Crashing Through Quitting Points</em></span></p>
<p class="first"><span href="#/Text/08CHAP06" title="Link target outside of Sample">6 Tender Love: <em>Walking in Someone Else’s Shoes</em></span></p>
<p class="first"><span href="#/Text/09CHAP07" title="Link target outside of Sample">7 Tough Love: <em>Insisting on Truth in Relationships</em></span></p>
<p class="first"><span href="#/Text/10CHAP08" title="Link target outside of Sample">8 Sacrificial Love: <em>Giving Without Giving Out</em></span></p>
<p class="first"><span href="#/Text/11CHAP09" title="Link target outside of Sample">9 Radical Love: <em>Breaking the Hostility Cycle</em></span></p>
<p class="first"><span href="#/Text/12CHAP10" title="Link target outside of Sample">10 A New Day: <em>The Christlikeness That We Crave</em></span></p>
<p class="first"><span href="#/Text/13CHAP11" title="Link target outside of Sample">11 World-Change: <em>When Character Counts Most</em></span></p>
<p class="first"><span href="#/Text/DiscussionGuide" title="Link target outside of Sample">Discussion Guide</span></p>
<p class="first"><span href="#/Text/AuthorInfo" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?25147dd1